import { render, staticRenderFns } from "./lookRemark.vue?vue&type=template&id=5b49f0cf&scoped=true"
import script from "./lookRemark.vue?vue&type=script&lang=ts"
export * from "./lookRemark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b49f0cf",
  null
  
)

export default component.exports